export default {

  ['loader'](state, flag) {
    state.loader = flag;
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutations.js